import React, { Component } from "react";

class DefaultHeader extends Component {

    render() {
        
        return (
            <div className="s360-default-header" style={this.headerStyle()}>
                {/* <div className="s360-default-header-image">
                    <img src={this.props.config.configDetails.brandIcon} style={{objectFit:"contain"}} border-radius={this.props.config.designDetails.brandRadius} width={this.props.config.designDetails.brandWidth} height={this.props.config.designDetails.brandHeight} alt="" />
                </div> */}
                {/* <div className="s360-default-header-name" >
                    {this.props.config.configDetails.brandName}
                </div> */}
                <div className="s360-default-header-icon" onClick={this.onClose} role="button" tabIndex={0} aria-label="Close chat" onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.onClose(); } }}>
                    
                  <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24.674 24.668"><defs></defs><path className="a" style={{fill: "white"}} d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z" transform="translate(-11.285 -11.289)"/></svg>
                </div>
            </div>
        )
    }

    onClose = () => {
        
        this.props.actions && this.props.actions.onHideChatWindow && this.props.actions.onHideChatWindow();
    }

    headerStyle = () => {
        const design = this.props.config.designDetails;
        return {
            backgroundColor: design.headerBackgroundImage !== "" && design.headerBackgroundImage !== undefined?"transparent":design.headerColor,
            color:           design.headerFontColor,
            fontFamily:      design.headerFont,
            fontSize:        design.headerFontSize,
            borderColor:     design.headerColor,
            

        }
    }

}

export default DefaultHeader;